// Typed-loose Supabase client wrapper for dashboard/admin use.
// The auto-generated types.ts in this template can lag behind migrations;
// the dashboard pages query many tables, so we re-export a permissive client.
import { supabase as typedClient } from "@/integrations/supabase/client";

export const sb = typedClient as unknown as {
  from: (table: string) => any;
  rpc: (fn: string, args?: any) => any;
  storage: typeof typedClient.storage;
  auth: typeof typedClient.auth;
  functions: typeof typedClient.functions;
};
